'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = YearSelect;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function YearSelect(p) {

    var propTypes = {
        'numYears': _react2['default'].PropTypes.Number
    };

    var curYear = new Date().getFullYear();
    var numYears = p.numYears || 10;
    var yearOptions = Array.apply(null, Array(numYears)).map(function (val, offset) {
        var year = curYear + offset;
        return _react2['default'].createElement(
            'option',
            { value: year, key: offset },
            year
        );
    });

    var value = p.value || curYear;

    return _react2['default'].createElement(
        'select',
        { className: 'm-payment--cc-exp-year', value: value, onChange: p.onChange },
        yearOptions
    );
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/payment-page/year-select.jsx
 ** module id = 1123
 ** module chunks = 0
 **/